<!-- El contenido es el mismo lleve enlace o no; sólo cambia el elemento que lo
     envuelve, para no duplicar el markup. -->
<ng-template #content>

  <span class="z-kpi-label">{{ label }}</span>

  <div class="stat-main">
    <span class="z-kpi-value">{{ value }}@if (suffix) {<small class="stat-suffix">{{ suffix }}</small>}</span>

    @if (icon) {
      <span class="stat-icon" aria-hidden="true"><i class="bi {{ icon }}"></i></span>
    }
  </div>

  @if (hasFoot) {
    <div class="z-kpi-foot">
      @if (hasDelta) {
        <span class="z-delta z-delta--{{ trend }}">
          <i class="bi {{ trendIcon }}" aria-hidden="true"></i>
          <span>{{ deltaText }}</span>
          <span class="z-sr-only">{{ trendLabel }}</span>
        </span>
      }

      @if (hint) {
        <span class="stat-hint">{{ hint }}</span>
      }

      @if (route) {
        <span class="stat-go" aria-hidden="true"><i class="bi bi-arrow-right-short"></i></span>
      }
    </div>
  }

</ng-template>

@if (route) {
  <a class="z-kpi-card stat stat--link" [routerLink]="route">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
    <span class="z-sr-only">Ver detalle</span>
  </a>
} @else {
  <div class="z-kpi-card stat">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </div>
}
